<template>
	<div class="deposit">
		<Modal :open-state="open" @close="() => open = false" title="Пополнение баланса" dialog-class="modal--lg">
			<div v-if="isLoaded">
				<div v-if="!isHost2Host">
					<PaymentSystems v-if="paymentTypes" :items="paymentTypes" :selected-type="selectedType"
						@set-type="selectType" />

					<div class="fields__item">
						<div v-if="isCryptoType && selectedType && selectedType.currency">
							<span class="badge badge--secondary">
								1 {{ selectedType.title }} ≈ {{ $root.currency(selectedType.currency) }}
							</span>
						</div>

						<div class="fields__item">

							<template v-if="selectedType">
								<span class="badge badge--secondary">
									Комиссия: {{ selectedType.min_commission }}%
								</span>
								<span v-if="selectedType.min_commission">
									К оплате с учётом комиссии:
									<b>
										{{ Math.round(amount) + (Math.round(amount) / 100 * selectedType.min_commission)
										}} ₽
									</b>
								</span>
							</template>
						</div>
					</div>

					<div class="fields__item">
						<vue-recaptcha ref="recaptcha" :sitekey="$root.$reCaptchaSiteKey" @verify="onCaptchaVerified"
							@expired="onCaptchaExpired">
						</vue-recaptcha>
					</div>

					<div class="fields__item" v-if="isCryptoType">
						<div class="fields__row">
							<div class="fields__item">
								<button @click="deposit" :disabled="!selectedType || disableBtn"
									:class="{'disabled':!selectedType || disableBtn}"
									class="btn btn--primary btn--block">
									Получить кошелёк
								</button>
							</div>
							<div class="fields__item">
								<input autocomplete="off" class="text-field__input" placeholder="Промокод" type="text"
									v-model="promocode">
							</div>
						</div>
					</div>

					<div class="fields__item" v-else>
						<div class="fields__row fields__item">
							<div class="fields__item">
								<div class="text-field">
									<div class="text-field__label">
										Сумма <span v-if="selectedType">от {{ $root.currency(selectedType.min_amount) }}
											до
											{{ $root.currency(selectedType.max_amount) }}</span>
									</div>
									<input autocomplete="off" class="text-field__input" v-model="amount"
										placeholder="Введите сумму" type="number">
								</div>
							</div>
							<div class="fields__item">
								<div class="text-field">
									<label class="text-field__label">Промокод</label>
									<input autocomplete="off" class="text-field__input" v-model="promocode"
										placeholder="Введите промокод, если есть" name="promo">
								</div>
							</div>
						</div>

						<div class="fields__row fields__item" v-if="selectedType && selectedType.required_wallet">
							<div class="fields__item">
								<div class="text-field">
									<div class="text-field__label">
										Введите реквизиты, с которых будете платить
									</div>
									<input class="text-field__input" v-model="wallet"
										placeholder="Укажите реквизиты" type="text">
								</div>
							</div>
						</div>

						<div v-if="amountPresets" class="fields__item">
							<div class="alert alert--warning">Для получения реквизитов попробуйте выбрать сумму из
								списка ниже
								<div class="field-input__presets">
									<button class="btn btn--secondary field-input__preset"
										v-for="preset in amountPresets" @click="amount = preset">{{preset}}</button>
								</div>
							</div>
						</div>
						<button @click="deposit" :disabled="!selectedType || disableBtn"
							:class="{'disabled': !selectedType || disableBtn}" class="btn btn--primary btn--block">
							Перейти к оплате
						</button>
					</div>

					<div class="alert alert--warning">
						Не создавайте несколько заявок сразу, пополнение может не зачислиться. Если есть проблемы,
						пишите в <a :href="$root.$link.support">техподдержку</a>
					</div>
				</div>
				<div v-if="isHost2Host">
					<div class="fields__item alert alert--warning" v-if="isCryptoType">
						Обязательно убедитесь, что вы отправляете на данный кошелек <b>{{selectedType.title}}</b>
						<div>
							В случае ошибки ваши деньги могут будут утрачены безвозвратно
						</div>
						<div v-if="selectedType.min_amount">
							<div>
								Минимальная сумма: <b>{{selectedType.min_amount}} {{selectedType.title}}</b>
							</div>
							<div>
								Переводы меньше <b>{{selectedType.min_amount}} {{selectedType.title}}</b> не поступят на
								баланс
							</div>
						</div>
					</div>
					<div class="deposit__card" v-if="isCryptoType">
						<div class="fields__item" v-if="selectedType && selectedType.currency">
							1 {{ selectedType.title }} ≈ {{ $root.currency(selectedType.currency) }}
						</div>

						<div class="fields__item" v-if="paymentData.number">
							<div class="text-field__label">Реквизиты</div>
							<CopyField :text="paymentData.number" />
						</div>
						<div class="fields__item" v-if="isCryptoType && paymentData.number && !isMob">
							<img class="deposit__qr"
								:src="'https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=' + paymentData.number" />
						</div>
						<button class="btn btn--danger btn--lg btn--block"
							@click="isHost2Host = false">Отменить</button>
					</div>

					<div v-else class="deposit__card">
						<div class="alert alert--info fields__item" v-if="paymentData.currency && paymentData.type">
							Отправьте <b>{{ paymentData.amount }} {{ paymentData.payment_type }}</b> на указанные ниже
							реквизиты
						</div>
						<div class="alert alert--info fields__item" v-else>
							Отправьте <b>{{ paymentData.amount }}</b> рублей на указанные ниже реквизиты
						</div>
						<div class="fields__row fields__item">
							<div class="fields__col" v-if="paymentData.number">
								<div class="fields__label">Реквизиты</div>
								<CopyField :text="paymentData.number" />
							</div>
							<div class="fields__col" v-if="paymentData.payment_type && paymentData.currency">
								<div class="fields__label"><b>Сеть</b></div>
								<div>{{ paymentData.payment_type }}</div>
							</div>
							<div class="fields__col" v-if="paymentData.currency">
								<div class="fields__label"><b>Курс</b></div>
								<div>{{ paymentData.currency }}</div>
							</div>
							<div class="fields__col" v-if="paymentData.holder">
								<div class="fields__label">Получатель</div>
								<div>{{ paymentData.holder }}</div>
							</div>
							<div class="fields__col" v-if="paymentData.bank">
								<div class="fields__label">Банк</div>
								<div>{{ paymentData.bank_display_name ? paymentData.bank_display_name : paymentData.bank
									}}</div>
							</div>
							<div class="fields__col" v-if="paymentData.amount">
								<div class="fields__label">Сумма</div>
								<CopyField
									:text="paymentData.currency && paymentData.type ? paymentData.amount : `${paymentData.amount} ₽`"
									:value="paymentData.amount" />
							</div>
						</div>
						<button class="btn btn--danger btn--lg btn--block"
							@click="isHost2Host = false">Отменить</button>
					</div>
				</div>

				<div class="table-wrap" v-if="payments.length">
					<table class="table">
						<tbody>
							<tr v-for="payment in payments">
								<td class="text-left">
									<div>
										<b>{{ payment.id }}</b>
									</div>
									<small class="text-muted">
										{{ payment.date }}
									</small>
								</td>
								<td class="text-left">
									<div>
										<b>{{ $root.currency(payment.amount) }}</b>
									</div>
									<small class="text-muted">
										{{ payment.type }}
									</small>
								</td>
								<td class="text-right">
									<span class="badge badge--lg badge--warning-light"
										v-if="payment.status === 'pending'">
										<svg class="badge__icon">
											<use href="#svg-icon-time"></use>
										</svg>
										В обработке
									</span>
									<span class="badge badge--lg badge--success-light"
										v-if="payment.status === 'processed'">
										<svg class="badge__icon">
											<use href="#svg-icon-checkmark"></use>
										</svg>
										Выполнено
									</span>
									<span class="badge badge--lg badge--danger-light"
										v-if="payment.status === 'failed'">
										<svg class="badge__icon">
											<use href="#svg-icon-close"></use>
										</svg>
										Отменено
									</span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</Modal>
	</div>
</template>

<script>
	import PaymentSystems from "../../components/blocks/PaymentSystems.vue";
	import Modal from "../blocks/Modal.vue";
	import breakpointsMixin from '../../mixins/breakpoints-mixin.vue';
	import CopyField from "../blocks/CopyField.vue";
	import VueRecaptcha from './../../components/googlerecaptcha/GoogleReCaptcha.vue';

    const PAYMENT_TYPE_URL = 'url';
    const PAYMENT_TYPE_H2H = 'h2h';
    
    export default {
        components: {
			Modal,
			PaymentSystems,
			CopyField,
			VueRecaptcha,
		},

		mixins: [
			breakpointsMixin
		],

        data() {
            return {
                amount: null,
                promocode: null,
                disableBtn: false,
                payments: [],
                paymentTypes: [],
                selectedType: null,
                isLoaded: false,
                isHost2Host: false,
                paymentData: null,
				open: false,
				gRecaptchaResponse: null,
            }
        },
        mounted() {
            this.getPaymentMethods();
            this.getPayments();
			this.$root.emitter.on('openDepositModal', () => this.open = true)
        },

		computed: {
			isCryptoType() {
				return (this.selectedType && this.selectedType.group_code === 'crypto') || (this.isTablet && !this.selectedType);
			},

			amountPresets() {
				if (this.amount && this.selectedType?.min_amount <= this.amount && this.selectedType?.max_amount >= this.amount) {
					let min = this.amount - 20 >= this.selectedType.min_amount;
					let max = this.amount + 20 <= this.selectedType.max_amount;
					return [this.randomInteger(min ? this.amount  -  20 : this.amount + 1, max ? this.amount  +  20 : this.amount), this.randomInteger(min ? this.amount  -  20 : this.amount + 1, max ? this.amount  +  20 : this.amount), this.randomInteger(min ? this.amount  -  20 : this.amount + 1, max ? this.amount  +  20 : this.amount)]
				}
			}
		},

        methods: {
            deposit() {
                var amount = Math.round(this.amount);
                this.amount = amount;

                if (this.disableBtn) {
                    return;
                }

				if (!this.gRecaptchaResponse) {
					return this.$toast.error('Необходимо пройти капчу');
				}

                if(!this.selectedType) {
                    return this.$toast.error('Выберите платежную систему');
                }

				if(this.isCryptoType) {
					this.amount = 5000;
				}

				if(!this.amount) {
					return this.$toast.error('Введите сумму пополнения');
				}

				this.amount = Math.round(this.amount);

                if(this.amount > this.selectedType.max_amount) {
                    return this.$toast.error(`Максимальная сумма ${this.selectedType.max_amount}`);
                }

                if(this.amount < this.selectedType.min_amount) {
                    return this.$toast.error(`Минимальная сумма ${this.selectedType.min_amount}`);
                }

				this.disableBtn = true;

				this.$root.axios.post('/api/payments/create', {
					amount: this.amount,
					type_id: this.selectedType.id,
					promocode: this.promocode,
					recaptcha: this.gRecaptchaResponse
				}).then(res => {
					const data = res.data;

					if (data.success) {
						switch (data.details.type) {
							case PAYMENT_TYPE_URL:
								window.location.href = data.details.url;
								break;

							case PAYMENT_TYPE_H2H:
								this.isHost2Host = true;
								this.paymentData = data.details;
								break;
						}
					} else {
						this.$toast.error(data.message);
						this.onCaptchaExpired();
					}
				}).catch(error => {
					error = this.$root.graphql.axiosGetError(error);
					this.$toast.error(error);
					this.onCaptchaExpired();
				});

				this.disableBtn = false;
            },
            getPayments() {
                this.$root.axios.get('/api/payments/latest').then(res => {
                    this.payments = res.data;
                    this.isLoaded = true;
                });
            },
            getPaymentMethods() {
                this.$root.axios.get('/api/payments/methods').then(res => {
                    this.paymentTypes = res.data;  
                });
            },
			selectType(type) {
				this.selectedType = type;
			},
			onCaptchaVerified(response) {
				this.gRecaptchaResponse = response;
			},
			onCaptchaExpired() {
				this.$refs.recaptcha.reset();
			},
			randomInteger(min, max) {
				return Math.floor(min + Math.random() * (max + 1 - min));
			}
        },
        sockets: {
            payment_complete: function() {
                this.getPayments();
            }
        }
    }
</script>